import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { EventImageAspectRatioContainer } from './'

const EventImageWithAspectRatio = ({ children, classNames, alt, ...rest }) => (
  <EventImageAspectRatioContainer
    className={classnames('h-0 relative aspect-ratio-event-image', classNames.container)}
  >
    <img className="absolute left-0 top-0 w-full h-full object-cover" alt={alt} {...rest} />
    {children}
  </EventImageAspectRatioContainer>
)

EventImageWithAspectRatio.propTypes = {
  classNames: PropTypes.shape({
    container: PropTypes.string,
  }),
}

EventImageWithAspectRatio.defaultProps = {
  classNames: {},
}

export default EventImageWithAspectRatio
